import { SELECTED_USER_STORAGE_KEY } from 'constant/selectedAccount';

const storage = {
    accessToken: 'access_token',
    refreshToken: 'refresh_token',
    userRole: 'role',

    setAccessToken(token: string) {
        localStorage.setItem(this.accessToken, token);
    },

    getAccessToken(): string {
        const token: string | null = localStorage.getItem(this.accessToken);
        return token ? token : '';
    },

    removeAccessToken() {
        localStorage.removeItem(this.accessToken);
    },

    setRefreshToken(token: string) {
        localStorage.setItem(this.refreshToken, token);
    },

    getRefreshToken() {
        const token: string | null = localStorage.getItem(this.refreshToken);
        return token ? token : '';
    },

    removeRefreshToken() {
        localStorage.removeItem(this.refreshToken);
    },

    setUserRole(role: string) {
        localStorage.setItem(this.userRole, role);
    },

    getUserRole() {
        return localStorage.getItem(this.userRole);
    },

    removeUserRole() {
        localStorage.removeItem(this.userRole);
    },

    logout() {
        this.removeAccessToken();
        this.removeRefreshToken();
        this.removeUserRole();
        localStorage.removeItem('aliro_layout_mode');
        localStorage.removeItem(SELECTED_USER_STORAGE_KEY);
    },

    isAuthenticated() {
        return localStorage.getItem(this.refreshToken) !== null;
    },
};

export default storage;
